import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import { Sprite, Stage } from "@inlet/react-pixi/animated";
import useWindowSize from "./app/utils/useWindowSize";
import Map from "./app/scenarios/Map";
import Welcome from "./app/components/Welcome";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "./app/redux/store";
import Transition from "./app/scenarios/Transition";
import Registry from "./app/scenarios/Registry";
import rotate from "./app/assets/girar.svg";
import GameHTMLContainer from "./app/baseComponents/GameContainer/components/GameHTMLContainer";
import Withdrawals from "./app/scenarios/Withdrawals";
import FullWithdrawal from "./app/scenarios/FullWithdrawal";
import Pension from "./app/scenarios/Pension";
import Loans from "./app/scenarios/Loans";
import DataUpdate from "./app/scenarios/DataUpdate";
import AudioPlayer from "./app/components/AudioPlayer";
import VideoContainer from "./app/baseComponents/VideoContainer";
import CommentContainer from "./app/baseComponents/CommentContainer";
import LogOut from "./app/components/LogOut";
import Info from "./app/baseComponents/Info";
import instrucciones from "./app/assets/instrccionesprofuturo.png";
import info from "./app/assets/info.svg";
import { setFinished } from "./app/redux/features/audio";
import { setAnimationsPlaying } from "./app/redux/features/map/map";
import Loading from "./app/components/Loading";
import { setInfo } from "./app/redux/features/info";

const useFrameBusting = () => {
  useEffect(() => {
    const allowedDomain = process.env.REACT_APP_DOMAIN;
    const currentOrigin = window.self.location.origin;
    if (
      window.top !== window.self &&
      allowedDomain &&
      currentOrigin.includes(allowedDomain)
    ) {
      window.top.location.href = window.self.location.href;
    }
  }, []);
};

function App() {
  useFrameBusting();
  useWindowSize();
  const { section } = useSelector((state) => state.general);
  const { currentAudio, interrupted, loop } = useSelector(
    (state) => state.audio
  );
  const [isFirstRender, setFirstRender] = useState(true);
  const config = {
    size: { width: window.innerWidth, height: window.innerHeight },
    stage: {
      antialias: true,
      backgroundColor: 0xf2f8ff,
    },
  };

  //const [isAnimationsPlaying, setAnimationsPlaying] = useState(false);
  const [content, setContent] = useState(<Map />);
  const audio = useRef(new Audio(currentAudio));
  const [playing, setPlaying] = useState(false);
  const [showTitle, setShowTitle] = useState(0);
  const scale = window.innerWidth / 1536;
  const [showStage, setShowStage] = useState(false);

  const dispatch = useDispatch();

  audio.current.onended = () => {
    dispatch(setFinished(true));
  };

  useEffect(() => {}, []);

  useEffect(() => {
    if (!interrupted && playing) {
      audio.current.loop = loop;
      audio.current.play();
    } else {
      audio.current.pause();
    }
  }, [playing, interrupted]);

  useEffect(() => {
    if (isFirstRender) {
      setFirstRender(false);
    } else {
      dispatch(setFinished(false));
      audio.current.src = currentAudio;
      audio.current.loop = loop;
      setPlaying(false);
      setTimeout(() => {
        setPlaying(true);
      }, 500);
    }
  }, [currentAudio]);

  useEffect(() => {
    switch (section) {
      case "registry":
        setContent(<Registry />);
        break;
      case "withdrawals":
        setContent(<Withdrawals />);
        break;
      case "dataUpdate":
        setContent(<DataUpdate />);
        break;
      case "fullWithdrawal":
        setContent(<FullWithdrawal />);
        break;
      case "pension":
        setContent(<Pension />);
        break;
      case "loans":
        setContent(<Loans />);
        break;
      case "map":
        setContent(<Map />);
        break;
      default:
        setContent(<Map />);
        break;
    }
  }, [section]);

  const handleAudio = (playing) => {
    setPlaying(playing);
  };

  const handleStart = () => {
    handleAudio(true);
    dispatch(setAnimationsPlaying(true));
    setTimeout(() => {
      setShowTitle(1);
    }, 1000);
  };

  const loadStage = () => {
    setShowStage(true);
  };

  return (
    <>
      <div
        className="App"
        style={{ width: window.innerWidth, height: window.innerHeight }}
      >
        <div className="stage">
          {showStage && (
            <Stage {...config.size} options={config.stage}>
              <Provider store={store}>
                <Transition>{content}</Transition>
                <Info
                  scale={showTitle}
                  image={instrucciones}
                  close={() => {
                    setShowTitle(0);
                    dispatch(setInfo(false));
                  }}
                />
                <Sprite
                  image={info}
                  anchor={[1, 0]}
                  position={[
                    window.innerWidth - window.innerWidth * 0.06,
                    window.innerWidth * 0.008,
                  ]}
                  scale={scale}
                  interactive
                  click={() => {
                    setShowTitle(1);
                    dispatch(setInfo(true));
                  }}
                  cursor="pointer"
                />
              </Provider>
            </Stage>
          )}
        </div>

        <GameHTMLContainer />
        <VideoContainer />
        <CommentContainer />
        <Welcome onClose={handleStart} />
        <Loading onStart={loadStage} />
        {window.matchMedia("(orientation: portrait)").matches && (
          <div className="portrait-warning">
            <img src={rotate} />
          </div>
        )}
        <AudioPlayer
          isPlaying={!interrupted && playing}
          onPlay={() => handleAudio(true)}
          onPause={() => handleAudio(false)}
        />
        <LogOut navigateTo={"/"} />
      </div>
    </>
  );
}

export default App;
